import { SignatureSection } from 'components/generic'
import { useSelector } from 'react-redux'
import { onSubmit } from '../../utils'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Icon, IconType } from '@lmc/ui-kit'
import { useState } from 'react'
import { getRouteWithParams } from 'components/routes/utils'
import { GOALS } from 'components/routes/residents/goals'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Resident } from '@lmc/ts-common'
import { commonPatterns } from '../../../../../../utils/enhancedTestIds'

type GoalsSignatureProps = {
  goalTitle?: string
  buttonChildren: string | undefined
  onSignatureSuccess?: () => void
  testId?: string
}

const GoalsSignature = (props: GoalsSignatureProps) => {
  const { goalTitle = '', buttonChildren, onSignatureSuccess, testId } = props
  const baseId = testId || 'goals-signature'

  const { id: residentID, goalID } = useParams()
  const [isSignatureModalVisible, setSignatureModalVisible] = useState(false)

  const residents: Resident[] = useSelector(
    (state: any) => state.data.residents
  )
  const resident: Resident | undefined = residents?.find(
    (carer) => carer.id === residentID
  ) as Resident
  const [isSubmittingSignature, setIsSubmittingSignature] = useState(false)

  const navigate = useNavigate()

  const { t } = useTranslation()
  const translate = (key: string, variable?: any) =>
    t(`consent.createConsentForms.components.consentModal.${key}`, variable)

  const handleSubmit = async ({ formState, onSuccess }: any) => {
    if (isSubmittingSignature) return
    setIsSubmittingSignature(true)
    await onSubmit({
      formState,
      goalId: goalID,
      resident,
      goalTitle,
      onSuccess: () => {
        onSuccess()
      },
      onError: () => {
        setSignatureModalVisible(false)
      }
    })
  }
  const onAddSignatureClick = () => {
    setSignatureModalVisible(true)
  }

  return (
    <div data-testid={baseId}>
      <SignatureButton
        icon={<Icon customIcon={IconType.Signature} />}
        type="button"
        onClick={() => onAddSignatureClick()}
        data-testid={commonPatterns.button(baseId, 'add-signature')}
      >
        {buttonChildren}
      </SignatureButton>
      <SignatureSection
        title="Add a Consent Signature"
        resident={resident}
        logs={[]}
        buttonLabel="Sign"
        footerLabel={goalTitle}
        confirmText={translate('confirm', {
          variable: resident?.preferredName || resident?.name?.first
        })}
        isSubmitting={isSubmittingSignature}
        helpUrl="helpUrl"
        onSubmit={handleSubmit}
        isModalOnly
        isModalVisible={isSignatureModalVisible}
        onClose={() => setSignatureModalVisible(false)}
        onSuccessClose={() => {
          onSignatureSuccess?.()
          navigate(getRouteWithParams(GOALS.VIEW, { id: residentID, goalID }))
        }}
        data-testid={`${baseId}-modal`}
      />
    </div>
  )
}

const SignatureButton = styled(Button)`
  height: 24px;
`

export default GoalsSignature
